import React from 'react'

// @todo: remove routes and unused components
const TeamEditContainer = () => {
  React.useEffect(() => {
    return function cleanup() {}
  }, [])

  // return <PricingBilling changeTab={e => e} />
  return null;
}

TeamEditContainer.propTypes = {}

export default TeamEditContainer
